const normalizePhoneNumber = (phoneNumber) => {
  if (phoneNumber.startsWith('+')) {
    return phoneNumber
      .replace(/[^0-9]/g, '') // Remove all non-numeric-characters
      .replace(/^/, '+');
  }

  return phoneNumber
    .replace(/^[0]/g, '') // Remove leading zeroes
    .replace(/[^0-9]/g, '') // Remove all non-numeric-characters
    .replace(/(.+)/, '+46$1'); // Add +46
};

export default normalizePhoneNumber;
